import React from 'react';

/*
 *  @Author:        Sergio Balaguer Carmona
 *  @Description:   Stateless component that renders a Heart icon.
 */

const View = ( props ) => {

    return (<g id="path">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
        </g>
    )

};

export default View;

